var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"navigation-panel"}},[_c('app-header'),_c('div',{staticClass:"container"},[_c('a-row',[_c('a-col',{attrs:{"span":12}},[_c('wizzard-progress')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }